import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { ExpenseReport } from '../models/expense_report';

export const downloadPDF = (reports: ExpenseReport[], exportName: string) => {
  const doc = new jsPDF();


  doc.addImage('/logo_notacito.png', 'PNG', 14, 10, 16, 16); 
  
  doc.setFontSize(22);
  doc.setTextColor(15, 23, 42); 
  doc.setFont("helvetica", "bold");
  doc.text("Notacito", 34, 22);

  doc.setFontSize(16);
  doc.setFont("helvetica", "normal");
  doc.text(`Notes de frais - ${exportName}`, 14, 40);
  
  doc.setFontSize(10);
  doc.setTextColor(100, 116, 139); 
  doc.text(`Document généré le : ${new Date().toLocaleDateString('fr-FR')}`, 14, 47);

  const tableColumn = ["Date", "Collaborateur", "Catégorie", "Fournisseur", "Description", "HT", "TVA", "TTC", "Statut"];
  const tableRows: any[] = [];
  
  let totalTTC = 0;

  reports.forEach(r => {
    const date = r.expense_date ? new Date(r.expense_date).toLocaleDateString("fr-FR") : "";
    
    const userFirstName = r.user?.first_name || "";
    const userLastName = r.user?.last_name || "";
    const actualEmployee = `${userFirstName} ${userLastName}`.trim() || "-";

    const category = r.category?.item_type || "";
    const supplier = r.supplier_name || "";
    const description = r.comment || "";
    
    const shortDesc = description.length > 20 ? description.substring(0, 17) + '...' : description;
    
    const ttc = Number(r.amount) || 0;
    const vat = Number(r.vat_amount) || 0;
    const ht = ttc - vat;
    
    totalTTC += ttc;
    const status = r.status || "";

    tableRows.push([
      date,
      actualEmployee, 
      category,
      supplier,
      shortDesc,
      `${ht.toFixed(2)} €`,
      `${vat.toFixed(2)} €`,
      `${ttc.toFixed(2)} €`,
      status
    ]);
  });

  autoTable(doc, {
    head: [tableColumn],
    body: tableRows,
    startY: 55, 
    theme: 'striped', 
    styles: { fontSize: 7 }, 
    headStyles: { fillColor: [40, 91, 177] }, 
    foot: [["", "", "", "", "TOTAL TTC", "", "", `${totalTTC.toFixed(2)} €`, ""]],
    footStyles: { fillColor: [241, 245, 249], textColor: [15, 23, 42], fontStyle: 'bold' }
  });

  const pageHeight = doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
  
  doc.setFontSize(7);
  doc.setTextColor(150, 150, 150);
  doc.setFont("helvetica", "normal");
  
  const legalText1 = "RK Development  - FRANCE";
  const legalText2 = "SIREN : 890322043 - Dispensé d'immatriculation au RCS et au RM";
  const legalText3 = "TVA non applicable, art. 293 B du CGI";
  
  doc.text(legalText1, 105, pageHeight - 15, { align: "center" });
  doc.text(legalText2, 105, pageHeight - 11, { align: "center" });
  doc.text(legalText3, 105, pageHeight - 7, { align: "center" });

  const filename = `export_${exportName.replace(/\s+/g, '_')}_${new Date().getTime()}.pdf`;
  doc.save(filename);
};